<template>
    <form class="SubForm" v-on:submit.prevent>
        <h3>New Combination</h3>
        <!-- Generic Combination Info -->
        <div class="row">
            <div class="column">
                <label>Name</label><input type="text" v-model="combination.name">
                <label>Standard Config</label><input type="checkbox" v-model="combination.is_standard_config">
                <label>Outdoor Locker</label><input type="checkbox" v-model="combination.is_outdoor">
                <label>Price</label><input type="number" step="0.01" v-model="combination.totalPrice">
            </div>
            <div class="column">
                <label>Num Lockers</label><input type="number" v-model="combination.totalLockers">
                <label>Height (mm)</label><input type="number" v-model="combination.totalHeight">
                <label>Width (mm)</label><input type="number" v-model="combination.totalWidth">
                <label>Depth (mm)</label><input type="number" v-model="combination.totalDepth">
            </div>
        </div>
        
        <!-- Image Uploads -->
        <div class="row">
            <div class="column">
                <label>Locker Image</label>
                <input type="file" @change="handleEuroImageUpload" accept="image/png,image/jpeg,image/jpg,image/gif,image/tiff,image/bmp" />
            </div>
            <div class="column">
                <label>Locker Dimensions</label>
                <input type="file" @change="handleEuroPlanUpload" accept="image/png,image/jpeg,image/jpg,image/gif,image/tiff,image/bmp" />
            </div>
        </div>
        
        <!-- Module List Controls -->
        <div class="row">
            <div class="column">
                <h3>Modules</h3>
                <button @click="addModule">Add Module</button> or <button @click="delModule">Remove Last Module</button>
            </div>
        </div>

        <!-- Dynamic List of Modules -->
        <div class="SubForm" v-for="(mod, index) in modules" :key="index">
            <div class="row">
                <div class="column">
                    <label>Module</label>
                    <select v-model="modules[index].id"><option v-for="modOpt in availableModules" :key="modOpt.id" :value="modOpt.id">{{modOpt.name}}</option></select>
                </div>
            </div>
        </div>

        <button @click="saveCombination">Save</button>
    </form>
</template>

<script>
    import {CallApi, fileToB64, isJimpSupportedMimeType} from '../Utilities.js'
    function moduleTemplate () { return {
        id: 0,
        ordinal: 0,
    }}

    export default {
        name: 'CombinationCreate',
        data: function() {
            return {
                dataLoaded: false,
                availableModules: [],
                combination: {
                    name: '',
                    is_standard_config: 0,
                    is_outdoor: 0,
                    totalPrice: 0,
                    totalDepth: 0,
                    totalWidth: 0,
                    totalHeight: 0,
                    totalLockers: 0,
                },
                modules: []
            }
        },
        methods: {
            addModule: function(){ this.modules.push(moduleTemplate()) },
            delModule: function(){ this.modules.pop() },
            fetchModules: async function() {
                this.availableModules = (await CallApi('GET', '/modules')).modules
                this.dataLoaded = true
            },
            handleEuroImageUpload: async function(event) {
                const file = event.target.files[0]
                if (file) {
                    if (!isJimpSupportedMimeType(file)) {
                        alert('Invalid file type. Please upload an image (jpg, png, gif, tiff, bmp)');
                        event.target.value = ''
                        return
                    }
                    this.combination.euroImage = await fileToB64(file)
                }
            },
            handleEuroPlanUpload: async function(event) {
                const file = event.target.files[0]
                if (file) {
                    if (!isJimpSupportedMimeType(file)) {
                        alert('Invalid file type. Please upload an image (jpg, png, gif, tiff, bmp)');
                        event.target.value = ''
                        return
                    }
                    this.combination.euroPlan = await fileToB64(file)
                }
            },
            saveCombination: async function() {
                // Set Ordinal Values
                this.modules.forEach((el, indx) => {
                    el.ordinal = indx
                })

                // Append Module to Combination Request
                this.combination.modules = this.modules

                // Post to Server
                const apiResult = await CallApi('POST', `/combinations`, this.combination)
                
                // Redirect to New Combination
                if (apiResult.combination) {
                    this.$router.push(`/lockercombinations/${apiResult.combination.id}`)
                }
            }
        },
        mounted: function() {
            this.fetchModules()
        }
    }
</script>